/**
 * Module dependencies.
 */

import { FormList } from 'app/components/organisms/crud/form-types';
import { requiredRule } from 'app/core/utils/field-rules';
import { TFunction } from 'react-i18next';

/**
 * Export `formFields`.
 */

export const formFields = (translate: TFunction): FormList => [
  {
    type: 'inputField',
    name: 'title',
    label: translate('common.labels.title'),
    rules: requiredRule(translate)
  },
  {
    type: 'inputField',
    inputType: 'textArea',
    rows: 4,
    name: 'description',
    label: translate('common.labels.description'),
    rules: undefined
  },
  {
    type: 'inputField',
    name: 'externalUrl',
    label: translate('common.labels.externalUrl'),
    rules: undefined
  },
  {
    type: 'selectField',
    name: 'status',
    label: translate('common.labels.status'),
    rules: undefined,
    options: [
      { value: 'active', label: String(translate('common.labels.active')) },
      { value: 'cancelled', label: String(translate('common.labels.statusLabels.cancelled')) }
    ]
  },
  {
    type: 'datePickerField',
    name: 'startDate',
    label: translate('common.labels.startDate'),
    disabled: true,
    rules: undefined
  },
  {
    type: 'datePickerField',
    name: 'endDate',
    label: translate('common.labels.endDate'),
    disabled: true,
    rules: undefined
  }
];
